import { useEffect, useState } from 'react';

type Message = {
	message: string;
	[key: string]: unknown;
};

const postMessage = (message: Message) => {
	// @ts-expect-error - tkt
	window.ReactNativeWebView?.postMessage(JSON.stringify(message));
};

const useReactNative = (onMessage?: (message: Message) => void) => {
	const [isReactNative, setIsReactNative] = useState(false);

	useEffect(() => {
		const handleMessage = (event: Event) => {
			const message = JSON.parse((event as MessageEvent).data);
			if (message.message === 'ReactNative') {
				setIsReactNative(true);
			} else {
				onMessage?.(message);
			}
		};
		postMessage({ message: 'isReactNative' });

		const isUIWebView = /\(ip.*applewebkit(?!.*(version|crios))/i.test(
			navigator.userAgent
		);
		const receiver = isUIWebView ? window : document;
		receiver.addEventListener('message', handleMessage);

		return () => {
			receiver.removeEventListener('message', handleMessage);
		};
	}, [onMessage]);

	return {
		isReactNative,
		postMessage,
	};
};

export default useReactNative;
